<template>
  <div class="songs-main" :class="`${createRenderType}-songs-main`">
    <div class="title">{{$$t('credit.newSongs')}}</div>
    <div class="list">
      <div class="card" v-for="item in list" :key="item">
        <GenreCard
          :data="item"
          type="newSongs"
          @changeFavorite="(state) => changeFavorite(item, state)"
          @handleMore="handleMore(item)"
          @togglePlay="togglePlay(item)"
          @onCurPlayEnded="onCurPlayEnded(item)"
          @handleShare="handleShare(item)"
          @handleSimilar="handleSimilar"
        ></GenreCard>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, getCurrentInstance } from "vue";
import { storeToRefs } from "pinia";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import GenreCard from "./genreCard.vue";

const globalProperties =
  getCurrentInstance()?.appContext.config.globalProperties;
const { $$t } = globalProperties?.$i18n;
const emits = defineEmits(["changeFavorite", "togglePlay", "onCurPlayEnded", "handleSimilar"]);
const props = defineProps({
  list: {
    type: Object,
    default: () => [],
  },
});
const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);

const changeFavorite = (item, state) => {
  emits("changeFavorite", item, state);
};

const handleMore = (item) => {
  emits("handleMore", item);
};

const togglePlay = (item) => {
  emits("togglePlay", item);
};

const onCurPlayEnded = (item) => {
  emits("onCurPlayEnded", item);
};

const handleShare = (item) => {
  emits("handleShare", item);
};
const handleSimilar = (item) => {
  emits("handleSimilar", item);
}
</script>

<style lang="scss">
.pc-songs-main {
  margin-top: 42px;
  .pull-to-load-main-list {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>

<style lang="scss" scoped>
.songs-main {
  margin-top: 36px;
  .title {
    font-weight: bold;
    padding-bottom: 16px;
  }
}
.pc-songs-main {
  margin-top: 52px;
  .title {
    padding-bottom: 24px;
    font-size: 32px;
    line-height: 42px;
  }
  .list {
    display: flex;
    flex-wrap: wrap;
    padding-right: 20px;
    .card {
      box-sizing: border-box;
      width: 50%;
      margin-bottom: 20px;
      &:nth-child(odd) {
        padding-right: 20px;
      }
      &:nth-child(even) {
        padding-left: 20px;
      }
    }
  }
}
.mobile-songs-main {
  margin-top: 36px;
  padding: 0 16px;
  .title {
    font-size: 24px;
    line-height: 32px;
  }
  .card {
    box-sizing: border-box;
    width: 100%;
    margin-bottom: 20px;
  }
}

@media screen and (min-width: 1800px) {
  .pc-songs-main {
    .title {
      font-size: 32px;
      line-height: 42px;
    }
    .list {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-column-gap: 40px;
      .card {
        box-sizing: border-box;
        width: 100%;
        margin-bottom: 20px;
        &:nth-child(odd) {
          padding-right: 0px;
        }
        &:nth-child(even) {
          padding-left: 0px;
        }
      }
    }
  }
}
</style>

